import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import CadernosPage from './pages/CadernosPage';
import RegaPage from './pages/RegaPage';
import EnergiaPage from './pages/EnergiaPage';
import FAQPage from './pages/FAQPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import { ThemeProvider } from './context/ThemeContext';
import ToastProvider from './components/ToastProvider';
import CookieBanner from './components/CookieBanner';
import './App.css';

const App = () => {
  return (
    <ThemeProvider>
      <ToastProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/cadernos" element={<CadernosPage />} />
              <Route path="/rega" element={<RegaPage />} />
              <Route path="/energia" element={<EnergiaPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/privacidade" element={<PrivacyPolicyPage />} />
              <Route path="/cookies" element={<CookiePolicyPage />} />
            </Routes>
            <CookieBanner />
          </div>
        </Router>
      </ToastProvider>
    </ThemeProvider>
  );
};

export default App;
